import { applyStyles } from '../../utils/styleUtils';

const ListElement = ({ element }) => {
    const style = applyStyles(element);

    // Determine list type (ordered or unordered)
    const ListTag = element.listType === 'unordered' ? 'ul' : 'ol';

    return (
        <div className="element-list" style={style}>
            <ListTag className={element.listType === 'unordered' ? 'element-list-ul' : 'element-list-ol'}>
                {element.items && element.items.map((item, index) => (
                    <li key={index} className="element-list-item">
                        {item}
                    </li>
                ))}
            </ListTag>
        </div>
    );
};

export default ListElement;

